import { Box, Collapse, Flex, Icon, Stack, Text, useColorModeValue, useDisclosure } from "@chakra-ui/react"
import { ChevronDownIcon } from "@chakra-ui/icons"
import { NavItem_t } from "../../NavBarTypes/NavItem";

function MobileNavItem({ label, children, href }: NavItem_t) {
    const { isOpen, onToggle, onClose, onOpen } = useDisclosure()

    return (
        <Stack spacing={4} onClick={children && onToggle} onMouseEnter={onOpen} onMouseLeave={onClose} >
            <Flex
                py={2}
                justifyContent="space-between"
                alignItems="center"
                _hover={{
                    textDecoration: 'none',
                }}
            >
                <Box 
                    as={href ? 'a' : 'div'}
                    cursor={href ? "pointer" : "default"}
                    {...(href && { href })}
                >
                    <Text fontWeight={600} color={useColorModeValue('gray.600', 'gray.200')}>
                        {label}
                    </Text>
                </Box>
                {children && (
                    <Icon
                        as={ChevronDownIcon}
                        transition={'all .25s ease-in-out'}
                        transform={isOpen ? 'rotate(180deg)' : ''}
                        w={6}
                        h={6}
                    />
                )}
            </Flex>

            {/* transition={{ exit: { duration: 0.5 }, enter: { duration: 0.5 } }} */}
            <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}  >
                <Stack
                    mt={2}
                    pl={4}
                    borderLeft={1}
                    borderStyle={'solid'}
                    borderColor={useColorModeValue('gray.200', 'gray.700')}
                    align={'start'}
                >
                    {children &&
                        children.map((child) => (
                            <Box as="a" key={child.label} py={2} href={child.href}
                                target={child.target ?? ''}>
                                {child.label}
                                <br></br>
                                {child.subLabel}
                            </Box>
                        ))}
                </Stack>
            </Collapse>
        </Stack>
    )
}

export default MobileNavItem;
